export default {
	accessRejections: {
		subtitle:
			'Personen, die die Nutzungsbedingungen oder die Datenschutzerklärung abgelehnt haben',
		unknownPerson: 'Unbekannte Person',
		openSinceOneDay: 'seit 1 Tag',
		openSinceDays: 'seit {count} Tagen',
		openSinceNone: '–',
		status: {
			locked: 'Gesperrt',
			pendingSync: 'Freigegeben, wartet auf Sync',
			stuck: 'Hängt seit {count} Tagen',
			waitingErp: 'Wartet auf Datenschutzfreigabe im ERP',
			done: 'Daten zurück',
			error: 'Rücksync fehlgeschlagen',
		},
		nomailHint:
			'Der automatische Versand von Zugangsdaten ist deaktiviert (Administration › E-Mail). Nach der Rückübertragung erhält die Person kein Zugangsschreiben von selbst – versenden Sie es über „Zugänge".',
		actions: {
			details: 'Details',
			forget: 'Fall vergessen',
		},
		release: {
			title: 'Zugang freigeben',
			text: 'Die Sperre wird aufgehoben. Beim nächsten Sync-Lauf werden die Daten der Person aus dem ERP-System zurückübertragen. Anschließend erhält die Person ein neues Zugangsschreiben und muss den Nutzungsbedingungen und der Datenschutzerklärung erneut zustimmen.',
			textNoMail:
				'Die Sperre wird aufgehoben. Beim nächsten Sync-Lauf werden die Daten der Person aus dem ERP-System zurückübertragen. Die Person muss den Nutzungsbedingungen und der Datenschutzerklärung erneut zustimmen.',
			hintNoMail:
				'Hinweis: Der automatische Versand von Zugangsdaten ist deaktiviert. Das Zugangsschreiben müssen Sie nach der Rückübertragung selbst über „Zugänge" versenden.',
			toast:
				'Zugang freigegeben. Die Rückübertragung erfolgt beim nächsten Sync-Lauf.',
		},
		forget: {
			title: 'Fall vergessen',
			text: 'Grabstein und Sperre verschwinden endgültig. Die Person wird beim nächsten Sync-Lauf wieder ganz normal hochgeladen und automatisch eingeladen, sofern sie im ERP-System aktiv ist – ohne erneute Zustimmung. Diese Aktion kann nicht rückgängig gemacht werden.',
			toast:
				'Fall entfernt. Die Person wird beim nächsten Sync-Lauf neu übertragen.',
		},
		case: {
			title: 'Fall {name}',
			historyTitle: 'Verlauf',
			history: {
				rejectedAt: 'Zugang abgelehnt',
				releasedAt: 'Freigegeben',
				syncClaimedAt: 'Vom Sync-Dienst übernommen',
				syncAckedAt: 'Rückmeldung des Sync-Dienstes: {result}',
				erpPrivacyCheckedAt: 'Datenschutzfreigabe im ERP geprüft: {value}',
				purgeDoneAt: 'Bereinigung abgeschlossen',
			},
			erpReleased: 'freigegeben',
			erpNotReleased: 'nicht freigegeben',
			syncResult: {
				ok: 'Daten zurückübertragen',
				no_erp_release: 'Datenschutzfreigabe im ERP fehlt',
				not_found: 'Person im ERP nicht gefunden',
				error: 'Fehler',
			},
			messageTitle: 'Meldung des Sync-Dienstes',
			messageEmpty: 'Noch keine Rückmeldung des Sync-Dienstes.',
		},
	},
}
